"use client";
import React, { createContext, useContext, useEffect, useState } from "react";

interface AuctionTimeContextValue {
    currentTime: number;
}

const AuctionTimeContext = createContext<AuctionTimeContextValue>({ currentTime: Date.now() });

export const useAuctionTime = () => useContext(AuctionTimeContext);

export const AuctionTimeProvider = ({ children }: { children: React.ReactNode }) => {
    const [currentTime, setCurrentTime] = useState(Date.now());

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(Date.now());
        }, 100);

        return () => clearInterval(interval);
    }, []);

    return (
        <AuctionTimeContext.Provider value={{ currentTime }}>
            {children}
        </AuctionTimeContext.Provider>
    );
};
